/**
 * This file was automatically generated by an automated script. Do not edit manually.
 */
import type { ModelProfile } from "@langchain/core/language_models/profile";
const PROFILES: Record<string, ModelProfile> = {
  "claude-sonnet-4-6": {
    maxInputTokens: 1000000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 128000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-haiku-4-5": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-6": {
    maxInputTokens: 1000000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 128000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-fable-5": {
    maxInputTokens: 1000000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 128000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-8": {
    maxInputTokens: 1000000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 128000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-1": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 32000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-sonnet-4-5": {
    maxInputTokens: 1000000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-sonnet-4-5-20250929": {
    maxInputTokens: 1000000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-5-20251101": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-haiku-4-5-20251001": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-7": {
    maxInputTokens: 1000000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 128000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-5": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 64000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-sonnet-5": {
    maxInputTokens: 1000000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 128000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-5": {
    maxInputTokens: 1000000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 128000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
  "claude-opus-4-1-20250805": {
    maxInputTokens: 200000,
    imageInputs: true,
    audioInputs: false,
    pdfInputs: true,
    videoInputs: false,
    maxOutputTokens: 32000,
    reasoningOutput: true,
    imageOutputs: false,
    audioOutputs: false,
    videoOutputs: false,
    toolCalling: true,
    structuredOutput: false,
    imageUrlInputs: true,
    pdfToolMessage: true,
    imageToolMessage: true,
  },
};
export default PROFILES;
